import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets';
import { useCallback, useState } from 'react';
import { useGetWorkflowMetadataQuery } from '../../__generated__/chirp/com/hubspot/cv/macros/rpc/MacroRpc.hooks';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackStandaloneEvent } from '../usage-tracking/clients/usageTracker';
import { HELP_DESK_APP_NAMESPACE } from '../usage-tracking/contants/namespaces';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MacrosTray = ({
  selectedMacro,
  onRemoveMacro
}) => {
  var _workflowMetadata$res;
  const handleRemoveMacro = useCallback(() => {
    if (selectedMacro) {
      trackStandaloneEvent(HELP_DESK_APP_NAMESPACE, 'Interaction', {
        action: 'Macro Cleared'
      });
    }
    onRemoveMacro === null || onRemoveMacro === void 0 || onRemoveMacro();
  }, [selectedMacro, onRemoveMacro]);
  const workflowId = selectedMacro === null || selectedMacro === void 0 ? void 0 : selectedMacro.workflowId;
  const workflowCrmId = selectedMacro === null || selectedMacro === void 0 ? void 0 : selectedMacro.workflowCrmId;
  const macroName = selectedMacro === null || selectedMacro === void 0 ? void 0 : selectedMacro.name;
  const {
    data: workflowMetadata,
    loading,
    error
  } = useGetWorkflowMetadataQuery({
    variables: {
      workflowCrmId: workflowCrmId,
      workflowId: workflowId
    },
    skip: !workflowCrmId || !workflowId
  });
  const [isHovered, setIsHovered] = useState(false);
  const workflowName = workflowMetadata === null || workflowMetadata === void 0 || (_workflowMetadata$res = workflowMetadata.result) === null || _workflowMetadata$res === void 0 ? void 0 : _workflowMetadata$res.workflowName;
  const tagName = !loading && !workflowName ? macroName : workflowName;
  return selectedMacro && /*#__PURE__*/_jsxs(Flex, {
    paddingBlock: "200",
    marginInline: "200",
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: "100",
    borderBlockStartColor: "border-core-subtle",
    gap: "200",
    flexDirection: "column",
    children: [error && /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      "data-test-id": "macros-tray-error-state",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.macros-tray.error-state"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      blockSize: "40px",
      alignItems: "center",
      justifyContent: "space-between",
      "data-test-id": "macros-tray",
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: [/*#__PURE__*/_jsx(Tag, {
        use: error ? 'danger' : 'default',
        children: tagName
      }), isHovered && /*#__PURE__*/_jsx(IconButton, {
        size: "extra-small",
        use: "transparent",
        "data-test-id": "remove-macro-button",
        onClick: handleRemoveMacro,
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })]
    })]
  });
};
MacrosTray.displayName = 'MacrosTray';